import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getToken();

  if (!token) {
    authService.clearSession();

    return router.createUrlTree(['/login']);
  }

  return authService.me().pipe(
    map(() => true),

    catchError(() => {
      authService.clearSession();

      return of(
        router.createUrlTree(['/login'])
      );
    })
  );
};